import { render, staticRenderFns } from "./AtenaLabelSuggest.vue?vue&type=template&id=44e60c1c&scoped=true"
import script from "./AtenaLabelSuggest.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaLabelSuggest.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AtenaLabelSuggest.vue?vue&type=style&index=0&id=44e60c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e60c1c",
  null
  
)

export default component.exports